import { createReducer } from '@reduxjs/toolkit';

import { apiRequestSuccess } from 'services/api/api.actions';
import { grantEndpoint } from 'services/grant/grant.config';
import { PostGrantResponse } from 'services/grant/grant.types';

const initialState = {
  grant: {} as PostGrantResponse,
};

const grantReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    const grant = payload?.response?.data;

    if (payload.resourceId === grantEndpoint) {
      state.grant = grant;
    }
  }),
);

export default grantReducer;
